import { useEffect } from "react";
import { startMatchCreativeProductAsset } from "../actions/user";
import { useDispatchApp } from "../lib/redux";
import {
  applyMatchedProductAsset,
  buildMatchCreativeProductPayload,
} from "../utils/matchCreativeProductAsset";

export const useMatchCreativeProductOnOpen = ({
  modalOpen,
  getValues,
  setValue,
  campaignID,
  initialValues = {},
  enabled = true,
  onProductMatched = () => {},
}) => {
  const dispatch = useDispatchApp();

  useEffect(() => {
    if (!enabled || !modalOpen) return;

    const existingImages = getValues("imagesUrl") || [];
    if (existingImages.length > 0) return;

    const existingReferenceAdUrl = getValues("referenceAdUrl")?.trim();
    if (existingReferenceAdUrl) return;

    const initialImages = initialValues.imagesUrl || [];
    if (initialImages.length > 0) return;

    if (initialValues.referenceAdUrl?.trim()) return;

    let isCancelled = false;

    const runProductMatch = async () => {
      try {
        const payload = buildMatchCreativeProductPayload({
          formValues: getValues(),
          campaignID,
          initialValues,
        });

        const response = await dispatch(
          startMatchCreativeProductAsset(payload)
        );
        if (isCancelled) return;

        applyMatchedProductAsset({
          response,
          getValues,
          setValue,
          onProductMatched,
        });
      } catch {
        // Silent fail — auto-match is optional and must not block the modal
      }
    };

    runProductMatch();

    return () => {
      isCancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalOpen]);
};
